import { render, staticRenderFns } from "./AdminMetaFieldEdit.vue?vue&type=template&id=55772b26&"
import script from "./AdminMetaFieldEdit.vue?vue&type=script&lang=js&"
export * from "./AdminMetaFieldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports